/* CutyPet — recherche prédictive. v2 — 20.09.2026

   Corrige, par rapport à la v1 :
   - l'endpoint et les liens ignoraient la locale (résultats et pages en anglais sur /fr et /de)
   - aucune annulation des requêtes en vol : les réponses pouvaient s'afficher dans le désordre
   - pas de prix, pas d'état de chargement, pas d'état vide
   - produits internes (cadeaux, protection colis, guides) visibles dans les résultats
   - blocage du scroll cassé sur iOS, pas de piège à focus, pas de navigation clavier
*/
(function () {
  var cfgEl = document.getElementById('cp-search-config');
  var root = document.getElementById('cp-search');
  if (!cfgEl || !root) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var panel = root.querySelector('.cp-search__panel');
  var form = root.querySelector('.cp-search__bar');
  var input = document.getElementById('cp-search-input');
  var clearBtn = root.querySelector('.cp-search__clear');
  var body = root.querySelector('.cp-search__body');

  var RECENT_KEY = 'cp_recent_searches';
  var MIN_CHARS = 2;
  var DEBOUNCE = 180;

  var timer = null;
  var controller = null;
  var lastQuery = '';
  var opener = null;
  var scrollY = 0;
  var activeIndex = -1;

  /* —— utilitaires —— */

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function highlight(title, q) {
    var safe = esc(title);
    var terms = q.split(/\s+/).filter(function (t) { return t.length > 1; });
    terms.forEach(function (t) {
      var re = new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'gi');
      safe = safe.replace(re, '<mark>$1</mark>');
    });
    return safe;
  }

  function money(value) {
    var n = parseFloat(String(value).replace(/[^0-9.,-]/g, '').replace(',', '.'));
    if (isNaN(n)) return '';
    try {
      return new Intl.NumberFormat(CFG.locale || 'en', {
        style: 'currency',
        currency: CFG.currency || 'USD',
        minimumFractionDigits: n % 1 === 0 ? 0 : 2
      }).format(n);
    } catch (e) {
      return n.toFixed(2) + ' ' + (CFG.currency || '');
    }
  }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=160';
  }

  function isHidden(p) {
    var handle = (p.handle || '').toLowerCase();
    if (CFG.exclude && CFG.exclude.indexOf(handle) !== -1) return true;
    var price = parseFloat(String(p.price).replace(',', '.'));
    return !isNaN(price) && price === 0;
  }

  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; }
  }

  function pushRecent(q) {
    if (!q) return;
    try {
      var list = getRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      list.unshift(q);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 4)));
    } catch (e) { /* navigation privée : on s'en passe */ }
  }

  /* —— rendus —— */

  function chips(label, items) {
    if (!items || !items.length) return '';
    return '<div class="cp-search__label">' + esc(label) + '</div><div class="cp-search__chips">' +
      items.map(function (t) {
        return '<button type="button" class="cp-search__chip" data-cp-term="' + esc(t) + '">' + esc(t) + '</button>';
      }).join('') + '</div>';
  }

  function renderIdle() {
    activeIndex = -1;
    body.innerHTML = chips(CFG.strings.recent, getRecent()) + chips(CFG.strings.popular, CFG.popular);
  }

  function renderLoading() {
    var row = '<div class="cp-search__skeleton"><div class="cp-search__sk cp-search__sk--img"></div>' +
      '<div style="flex:1"><div class="cp-search__sk cp-search__sk--l1"></div>' +
      '<div class="cp-search__sk cp-search__sk--l2"></div></div></div>';
    body.innerHTML = row + row + row;
  }

  function renderResults(products, q) {
    activeIndex = -1;
    if (!products.length) {
      body.innerHTML = '<div class="cp-search__empty">' + CFG.strings.noResults.replace('{q}', '<strong>' + esc(q) + '</strong>') + '</div>' +
        chips(CFG.strings.popular, CFG.popular);
      return;
    }

    var rows = products.map(function (p, i) {
      var price = money(p.price);
      var compare = p.compare_at_price && parseFloat(p.compare_at_price) > parseFloat(p.price) ? money(p.compare_at_price) : '';
      var media = p.image
        ? '<img class="cp-search__thumb" src="' + esc(thumb(p.image)) + '" alt="" loading="lazy" width="54" height="54">'
        : '<span class="cp-search__thumb" aria-hidden="true"></span>';
      return '<a class="cp-search__row" role="option" aria-selected="false" data-i="' + i + '" href="' + esc(p.url) + '">' +
        media +
        '<span class="cp-search__info">' +
        '<span class="cp-search__title">' + highlight(p.title, q) + '</span>' +
        (price ? '<span class="cp-search__price">' + price + (compare ? '<s>' + compare + '</s>' : '') + '</span>' : '') +
        '</span>' +
        '<svg class="cp-search__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 3l5 5-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</a>';
    }).join('');

    var all = '<a class="cp-search__all" href="' + CFG.searchUrl + '?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">' +
      esc(CFG.strings.seeAll) + '</a>';

    body.innerHTML = rows + all;
  }

  /* —— recherche —— */

  function run(q) {
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    var url = CFG.suggestUrl + '?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last';

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (q !== lastQuery) return; /* réponse périmée */
        var list = (d.resources && d.resources.results && d.resources.results.products) || [];
        renderResults(list.filter(function (p) { return !isHidden(p); }).slice(0, 6), q);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        if (q !== lastQuery) return;
        body.innerHTML = '<div class="cp-search__empty">' + esc(CFG.strings.error) + '</div>';
      });
  }

  function onInput() {
    var q = input.value.trim();
    clearBtn.hidden = q.length === 0;
    lastQuery = q;
    clearTimeout(timer);

    if (q.length < MIN_CHARS) {
      if (controller) controller.abort();
      renderIdle();
      return;
    }
    renderLoading();
    timer = setTimeout(function () { run(q); }, DEBOUNCE);
  }

  /* —— ouverture / fermeture —— */

  function lockScroll() {
    scrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function open(e) {
    if (e) { e.preventDefault(); opener = e.currentTarget; }
    if (!root.hidden) return;
    root.hidden = false;
    lockScroll();
    renderIdle();
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      setTimeout(function () { input.focus({ preventScroll: true }); }, 60);
    });
  }

  function close() {
    if (root.hidden) return;
    if (controller) controller.abort();
    clearTimeout(timer);
    root.classList.remove('is-open');
    var done = function () {
      root.hidden = true;
      unlockScroll();
      input.value = '';
      clearBtn.hidden = true;
      body.innerHTML = '';
      lastQuery = '';
      if (opener && opener.focus) opener.focus();
    };
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced) { done(); } else { setTimeout(done, 220); }
  }

  /* —— clavier —— */

  function rows() { return Array.prototype.slice.call(body.querySelectorAll('.cp-search__row')); }

  function setActive(i) {
    var list = rows();
    if (!list.length) return;
    if (i < 0) i = list.length - 1;
    if (i >= list.length) i = 0;
    list.forEach(function (el, n) {
      var on = n === i;
      el.classList.toggle('is-active', on);
      el.setAttribute('aria-selected', on ? 'true' : 'false');
      if (on) el.scrollIntoView({ block: 'nearest' });
    });
    activeIndex = i;
  }

  document.addEventListener('keydown', function (e) {
    if (root.hidden) return;

    if (e.key === 'Escape') { e.preventDefault(); close(); return; }

    if (e.key === 'ArrowDown') { e.preventDefault(); setActive(activeIndex + 1); return; }
    if (e.key === 'ArrowUp') { e.preventDefault(); setActive(activeIndex - 1); return; }

    if (e.key === 'Enter' && activeIndex > -1) {
      var el = rows()[activeIndex];
      if (el) { e.preventDefault(); pushRecent(input.value.trim()); window.location.href = el.getAttribute('href'); }
      return;
    }

    if (e.key === 'Tab') {
      var f = panel.querySelectorAll('a[href], button:not([hidden]), input:not([type=hidden])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* —— branchements —— */

  document.querySelectorAll('[data-cp-search]').forEach(function (el) { el.addEventListener('click', open); });
  root.querySelectorAll('[data-cp-close]').forEach(function (el) { el.addEventListener('click', close); });

  input.addEventListener('input', onInput);

  clearBtn.addEventListener('click', function () {
    input.value = '';
    clearBtn.hidden = true;
    lastQuery = '';
    renderIdle();
    input.focus();
  });

  form.addEventListener('submit', function (e) {
    var q = input.value.trim();
    if (!q) { e.preventDefault(); return; }
    pushRecent(q);
  });

  body.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-cp-term]');
    if (chip) {
      input.value = chip.getAttribute('data-cp-term');
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
      return;
    }
    var row = e.target.closest('.cp-search__row');
    if (row) pushRecent(input.value.trim());
  });

  window.addEventListener('pageshow', function () { if (root.hidden) unlockScroll(); });
})();
